import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant.js';

const _initialState = {
    tabIndex: 0,

    filterType: FJConstant.ALL,
    searchText: '',
    listStatus: FJConstant.DEFAULT,
    listPage: 1,
    listPageSize: 20,
    listTotal: 0,
};

export const FJSliceAIPhotoGenerator = createSlice({
    name: 'AIPhotoGenerator',
    initialState: {
        ..._initialState,
    },
    reducers: {
        reset: state => {
            state.filterType = _initialState.filterType;
            state.searchText = _initialState.searchText;
            state.listStatus = _initialState.listStatus;
            state.listPage = _initialState.listPage;
            state.listPageSize = _initialState.listPageSize;
            state.listTotal = _initialState.listTotal;
        },
        setSliceTabIndex: (state, action) => {
            state.tabIndex = action.payload;
        },
        setSliceFilterType: (state, action) => {
            state.filterType = action.payload;
        },
        setSliceSearchText: (state, action) => {
            state.searchText = action.payload;
        },
        setSliceListStatus: (state, action) => {
            state.listStatus = action.payload;
        },
        setSliceListPage: (state, action) => {
            state.listPage = action.payload;
        },
        setSliceListPageSize: (state, action) => {
            state.listPageSize = action.payload;
        },
        setSliceListTotal: (state, action) => {
            state.listTotal = action.payload;
        },
    },
});

export const {
    setSliceTabIndex,
    setSliceFilterType,
    setSliceSearchText,
    setSliceListStatus,
    setSliceListPage,
    setSliceListPageSize,
    setSliceListTotal,
    reset,
} = FJSliceAIPhotoGenerator.actions;

export default FJSliceAIPhotoGenerator.reducer;
